module.exports = __webpack_public_path__ + "static/media/officerup-new.1f04081e.jpg";